import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import axios from 'axios';

// 微信图标 SVG (Ant Design)
const WechatIcon = () => (
  <svg
    viewBox="0 0 1024 1024"
    width="20"
    height="20"
    fill="currentColor"
    style={{ marginRight: '8px' }}
  >
    <path d="M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z"/>
  </svg>
);

export default function StripeWechatPayButton({amount, productName, productInfo}) {
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(true)
    axios.post('https://coco-excel.mindlink.work/api/get-stripe-checkout-url', {
      amount: amount,
      product_name: productName,
      product_info: {
          "product_name": productInfo.product_name,
          "product": productInfo.product,
          "product_term": productInfo.product_term,
          "product_share_link": productInfo.product_share_link
      }
    }).then(res => {
      const targetUrl = res.data?.session_url;
      if (targetUrl) {
          // 方法2：降级方案 - 在当前窗口打开
          window.location = targetUrl;
      } else {
        alert('未获取到有效订单信息');
      }
    }).catch(error => {
      console.error('获取URL失败:', error);
    }).finally(res => {
      setOpen(false) 
    })
  }

  return (
    <frameElement>
        <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Button
        variant="contained"
        sx={{
          backgroundColor: "#EF7F95",
          color: "#fff",
          '&:hover': {
            backgroundColor: "#E56A85",
          },
        }}
        onClick={handleClick}
      >
        <WechatIcon />
        微信支付
      </Button>
    </frameElement>
  );
}
